import React from 'react';
import { Link } from 'react-router-dom';
import './Projects.css';
import FeaturedProjects from '../Components/FeaturedProjects';
import ClientsCarousel from '../Components/ClientsCarousel';

function Projects() {

  return (
    <div className="projects-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Our Projects</h1>
          <p>Showcasing our engineering excellence and commitment to structural safety.</p>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="section bg-light">
        <div className="container">
          <FeaturedProjects />
        </div>
      </section>

      {/* Trust Section */}
      <ClientsCarousel />

      <section className="section">
        <div className="container text-center">
          <div className="mt-3">
            <Link to="/contact" className="btn btn-primary">Start Your Project With Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Projects;